"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _item_component = _interopRequireDefault(require("./component/item_component"));

var _link_component = _interopRequireDefault(require("./component/link_component"));

var _dom_component = _interopRequireDefault(require("./component/dom_component"));

var _toggle_component = _interopRequireDefault(require("./component/toggle_component"));

var _icon_component = _interopRequireDefault(require("./component/icon_component"));

var _index = require("./utils/index");

var _compact_props = _interopRequireDefault(require("./utils/compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Menu =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Menu, _PureComponent);

  /**
   * 组件属性说明
   * @alias MenuProps
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基本属性
   * @property {array} data=[]] 菜单数据
   * @property {boolean} [show] 是否展示
   * @property {string} [value] 展示选中的值（对应节点的url或者key）
   * @property {array} [hideValue=[]] 隐藏对应的节点（数据为data中的节点key或href）
   * @property {func} [onChange] 选中值切换 onChange = (event, data) // data为对应节点数据
   * @property {bool} [defaultOpenValue=false] 初始化时，如果value不在open内是否进行展开
   * @property {bool} [showOpenSubMenuInDidMount=true] 初始化为缩放状态时，如果指定了open是否需要在didmount的时就展示下子菜单浮层
   * @property {array|string} [open] 激活展开状态（如果传入的是字符串意味着只展开一项，数组就是多项，值为对应节点的key或href, 旧名称为active）
   * @property {func} [onOpen] 切换展开状态<br />onOpen=(event, open) // 旧名称为onOpenChange
   * @property {bool} [fixed=true] menu是否为fixed样式
   * @property {number} [delay=1500] type为min且value中有值时，展示的popover延迟多久后消失，默认为1.5s，如果指定<=0，说明一直都在
   * @property {bool} [showPortalMenuWhenNoSubmenu=true] 当没有子菜单时显示浮层菜单（type为mini时才有效果）
   * @property {titleline} 展开收起相关属性
   * @property {string} [toggle=true] 可切换类型
   * @property {string} [toggleTitle='展开/收起菜单'] 收起展开按钮提示文案
   * @property {object} [toggleProps={}] 收起展开组件的props参数
   * @property {string} [groupClassName=''] 菜单选项底层className
   * @property {string} [type] 菜单收起/展开类型*可选值: mini(收起), normal(展开)*
   * @property {string} [miniClassNameInBody='spaui-menu-mini-in-body'] 当type=mini时在body处的className标记
   * @property {string} [defaultType='normal'] 默认展示类型
   * @property {func} [onTypeChange] 当toggle为true切换展示类型时的回调 onTypeChange = (event, type)
   * @property {number} [transitionWidthTime=300] 宽度动画时间(如果有动画的话，进行展开缩放时通过这个重新设置选中状态)
   * @property {bool} [triggerWindowResizeWhenTypeChange=false] 在切换type的时候是否触发window.resize
   * @property {titleline} 自定义组件属性
   * @property {func|element} [HeaderComponent] Header结构
   * @property {func|element} [FooterComponent] Footer结构
   * @property {func} [ItemComponent] 自定义元素结构
   * @property {func} [LinkComponent] 用于替换a标签，方便用于react-router的Link
   * @property {element|func} [ToggleComponent] 展开收起结构自定义结构
   * @property {element|func} [IconComponent] 图标结构
   * @property {titleline} 相关事件属性
   * @property {func} [onMenuItemMouseEnter] spaui-menuitem节点enter
   * @property {func} [onMenuItemMouseLeave] spaui-menuitem节点leave
   * @property {func} [onMenuItemTransitionEnd] spaui-menuitem节点transitionEnd
   * @property {func} [onMenuGroupTransitionEnd] spaui-menu-group节点transitionEnd
   * @property {titleline} 选中与展开判断逻辑
   * @property {func} [nodeIsSelected] 节点是否处于选中状态
   * @property {func} [nodeIsOpen] 节点是否处于展开状态
   * @property {titleline} 其他属性
   * @property {number|string} [width] 菜单宽度
   *
   * @see
   *
   * onChange typings:
   *     (event: any, data: any) => any
   *
   * ====
   *
   * onOpen typings:
   *     (event: any, activeResult: any, data: any) => any
   *
   * ====
   *
   * onTypeChange typings:
   *     (event: any, type: any) => any
   *
   * ====
   *
   * nodeIsSelected typings:
   *     (value: any, item: any, type: any) => any
   *
   * ====
   *
   * nodeIsOpen typings:
   *     (value: any, active: any, menuData: any, type: any) => any
   *
   * @example
   * // value对应传入组件的value；nodeData节点的数据；返回true or false；当前是展开还是收起
   * nodeIsSelected = (value, nodeData, type) => { return true or false; }
   * 默认：
   * nodeIsSelected = (value, nodeData = {}, type = '') {
          const { href = '', key = '', data = [] } = nodeData;
          let result = value && (value === href || value === key);
           // 如果是缩小且没有选中的还得看看子节点是否选中
          if (!result && type === 'mini') {
              data.map((item = {}) => {
                  if (item) {
                      if (!result && value && (value === item.href || value === item.key)) {
                          result = true;
                      }
                  }
                  return item;
              });
          }
           return result;
      }
   *
   *
   * &lt;HeaderComponent
  {...customProps}
  data={data}
  toggleTitle={toggleTitle}
  toggle={toggle}
  type={type}
  onTypeChange={onTypeChange}
  value={value}
  fixed={fixed}
  /&gt;
   *
   * &lt;FooterComponent
  {...customProps}
  data={data}
  toggleTitle={toggleTitle}
  toggle={toggle}
  type={type}
  onTypeChange={onTypeChange}
  value={value}
  fixed={fixed}
  /&gt;
   *
  &lt;LinkComponent
      {...aProps}
      {...dataAttribute}
  &gt;{children}&lt;/LinkComponent&gt;
   *
   *&lt;ToggleComponent
      title={toggleTitle}
      type={type}
      onChange={onTypeChange}
  /&gt;
   *
   * &lt;IconComponent
  type={type}
  theKey={itemKey}
  href={itemHref}
  value={value}
  label={label}
  data={data}
  iconClassName={iconClassName}
  selected={selected}
  /&gt;
   *
   */
  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setType", function (type) {
      var _compactProps = (0, _compact_props["default"])(_this.props),
          toggle = _compactProps.toggle;

      if (toggle) {
        _this.handleTypeChange({}, type);
      }
    });

    var _compactProps2 = (0, _compact_props["default"])(props),
        open = _compactProps2.open;

    _this.state = {
      type: props.type || props.defaultType,
      value: props.value || '',
      active: _this.getOpenValue(open, _this.props, true)
    };
    _this.id = props.id || (0, _index.uniqueId)();
    _this.leaveTimeout = null;

    _this.nullList();

    _this.timeout = null;
    _this.isActive = _this.isActive.bind(_assertThisInitialized(_this));
    _this.handleTypeChange = _this.handleTypeChange.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleMenuItemMouseEnter = _this.handleMenuItemMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMenuItemMouseLeave = _this.handleMenuItemMouseLeave.bind(_assertThisInitialized(_this));
    _this.handleMenuItemTransitionEnd = _this.handleMenuItemTransitionEnd.bind(_assertThisInitialized(_this));
    _this.handleMenuGroupTransitionEnd = _this.handleMenuGroupTransitionEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var showOpenSubMenuInDidMount = this.props.showOpenSubMenuInDidMount;
      this.updateMenuHeight();

      if (showOpenSubMenuInDidMount) {
        this.timeout = setTimeout(function () {
          _this2.showActiveSubMenu();
        }, this.getTimeOut());
      }

      this.classNameSignInBody();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.type !== 'undefined') {
        this.setState({
          type: nextProps.type
        });
      }

      if (typeof nextProps.value !== 'undefined') {
        this.setState({
          value: nextProps.value
        });
      }

      if (typeof nextProps.active !== 'undefined' || typeof nextProps.open !== 'undefined') {
        this.setState({
          active: this.getOpenValue(nextProps.active || nextProps.open, nextProps)
        });
      } else if (nextProps.value !== this.props.value) {
        if (this.isUpdateOpenValue(nextProps)) {
          this.setState({
            active: this.getOpenValue((0, _compact_props["default"])(nextProps).open, nextProps, true)
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var needForceUpdateHeight = prevProps.data !== this.props.data;
      this.updateMenuHeight(needForceUpdateHeight);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this3.showActiveSubMenu();
      }, this.getTimeOut());
      this.classNameSignInBody();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.groupRef = null;
      this.triggerWindowResizeWhenTypeChangeTimeout = null;
    }
  }, {
    key: "getTimeOut",
    value: function getTimeOut() {
      var _this$props$transitio = this.props.transitionWidthTime,
          transitionWidthTime = _this$props$transitio === void 0 ? 0 : _this$props$transitio;
      return transitionWidthTime || 5;
    } // 对外提供的用于控制type的方法

  }, {
    key: "isUpdateOpenValue",
    // 重新接受参数的时候，只有value非第一层的时候才重新设置下active，防止选中位置有变化
    value: function isUpdateOpenValue() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = this.getData(props);
      var _props$value = props.value,
          value = _props$value === void 0 ? '' : _props$value;
      var result = true;
      data.map(function (item) {
        if (result && (item.key === value || item.href === value)) {
          result = false;
        }

        return item;
      });
      return result;
    } // 获取初始化的时候的open数据

  }, {
    key: "getOpenValue",
    value: function getOpenValue(active) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var valueIsOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var data = this.getData(props);
      var _props$value2 = props.value,
          value = _props$value2 === void 0 ? '' : _props$value2,
          _props$defaultOpenVal = props.defaultOpenValue,
          defaultOpenValue = _props$defaultOpenVal === void 0 ? false : _props$defaultOpenVal;
      var result;
      var valueOpenKey = '';

      if (value) {
        data.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (value === item.href || value === item.key) {
            valueOpenKey = item.href || item.key;
          } else if (item.data && item.data.length > 0) {
            item.data.map(function (subItem) {
              if (value === subItem.href || value === subItem.key) {
                valueOpenKey = item.href || item.key;
              }

              return subItem;
            });
          }

          return item;
        });
      }

      if ((0, _spauiUtils.isArray)(active)) {
        result = active;
      } else if (typeof active !== 'undefined') {
        if (active) {
          result = [active];
        } else {
          // 如果没值，代表的是要关闭的
          result = [];
        }
      } // 第一次初始化的时候，如果value对应的openKey不在展开中，需要进行展开，后续就不需要这个逻辑了


      if (defaultOpenValue && valueOpenKey && valueIsOpen && (0, _spauiUtils.indexOf)(result, valueOpenKey) < 0) {
        if (!(0, _spauiUtils.isArray)(result)) {
          if (result) {
            result = [result];
          } else {
            result = [];
          }
        }

        result.push(valueOpenKey);
      }

      return result;
    } // 在body添加一个className

  }, {
    key: "classNameSignInBody",
    value: function classNameSignInBody() {
      var _this$props$miniClass = this.props.miniClassNameInBody,
          miniClassNameInBody = _this$props$miniClass === void 0 ? '' : _this$props$miniClass;
      var type = this.state.type;
      var $body = document.body; // 在body处添加标记

      if ($body && miniClassNameInBody) {
        (0, _spauiUtils.removeClassName)($body, miniClassNameInBody);

        if (type === 'mini') {
          (0, _spauiUtils.addClassName)($body, miniClassNameInBody);
        }
      }
    }
  }, {
    key: "handleTypeChange",
    value: function handleTypeChange(event, toggleType) {
      var _this4 = this;

      var _this$props = this.props,
          propsType = _this$props.type,
          onTypeChange = _this$props.onTypeChange,
          _this$props$triggerWi = _this$props.triggerWindowResizeWhenTypeChange,
          triggerWindowResizeWhenTypeChange = _this$props$triggerWi === void 0 ? false : _this$props$triggerWi;
      var type = this.state.type;

      var triggerWindowResize = function triggerWindowResize() {
        var haveJQuery = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.jQuery === 'function';

        if (triggerWindowResizeWhenTypeChange) {
          clearTimeout(_this4.triggerWindowResizeWhenTypeChangeTimeout);
          _this4.triggerWindowResizeWhenTypeChangeTimeout = setTimeout(function () {
            if (haveJQuery) {
              jQuery(window).trigger('resize');
            } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
              var resizeEvent = new Event('resize');

              if (window.dispatchEvent) {
                window.dispatchEvent(resizeEvent);
              } else if (window.fireEvent) {
                window.fireEvent(resizeEvent);
              }
            }
          }, _this4.getTimeOut());
        }
      };

      var result = ''; // 如果指定了，优先用指定的

      if (typeof toggleType !== 'undefined') {
        result = toggleType;
      } else {
        if (type === 'mini') {
          result = 'normal';
        } else {
          result = 'mini';
        }
      }

      if (typeof propsType === 'undefined') {
        this.setState({
          type: result
        }, function () {
          triggerWindowResize();
        });
      } else {
        triggerWindowResize();
      }

      if ((0, _spauiUtils.isFunction)(onTypeChange)) {
        onTypeChange(event, result);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      var menuData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          nodeIsOpen = _this$props2.nodeIsOpen,
          type = _this$props2.type;
      var _this$state = this.state,
          value = _this$state.value,
          active = _this$state.active;
      return nodeIsOpen(value, active, menuData, type);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, data, index) {
      var activeing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var noChangeValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;

      var _compactProps3 = (0, _compact_props["default"])(this.props),
          onOpen = _compactProps3.onOpen,
          propsActive = _compactProps3.open;

      var active = this.state.active;
      var activeKey = data.href || data.key || '';
      var activeResult; // 点击箭头的时候不响应change value

      if (!noChangeValue) {
        if (typeof value === 'undefined') {
          this.setState({
            value: data.href || data.key || ''
          });
        }

        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, data);
        }
      }

      if (index === 0 && activeKey && (0, _spauiUtils.isArray)(data.data) && data.data.length > 0) {
        if ((0, _spauiUtils.isArray)(propsActive)) {
          activeResult = [];
          active.map(function (activeItem) {
            if (activeItem && activeItem !== data.href && activeItem !== data.key) {
              activeResult.push(activeItem);
            }

            return activeItem;
          });

          if (!activeing) {
            activeResult.push(activeKey);
          }
        } else {
          if (activeing) {
            activeResult = '';
          } else {
            activeResult = activeKey;
          }
        }

        if (typeof propsActive === 'undefined') {
          if (!(0, _spauiUtils.isArray)(activeResult)) {
            if (activeResult) {
              activeResult = [activeResult];
            } else {
              activeResult = [];
            }
          }

          this.setState({
            active: activeResult
          });
        }

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, activeResult, data);
        }
      }
    }
  }, {
    key: "hideSubMenu",
    value: function hideSubMenu() {
      var data = this.getData(this.props);
      var id = this.id;
      var $id = null;
      var subMenuList = null;
      var subMenu = null;
      var i = 0;
      var len = 0;

      if (this.groupRef) {
        subMenuList = this.groupRef.getElementsByTagName('li');
        len = subMenuList.length;

        for (; i < len; i++) {
          subMenu = subMenuList[i];

          if (subMenu && subMenu.getAttribute('data-toplevel') && subMenu.getAttribute('data-open') === '1') {
            subMenu.setAttribute('data-open', '0');
          }
        }
      }

      data.map(function (item, index) {
        $id = document.getElementById("".concat(id, "_portal_").concat(index));

        if ($id) {
          $id.style.display = 'none';
        }

        return item;
      });
    }
  }, {
    key: "showSubMenu",
    value: function showSubMenu(theIndex) {
      var targetRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var id = this.id;
      var $id = null;
      var scrollTop = 0;
      this.hideSubMenu();

      if (typeof theIndex !== 'undefined') {
        $id = document.getElementById("".concat(id, "_portal_").concat(theIndex));

        if ($id) {
          $id.style.display = 'block';

          if (targetRect.y || targetRect.top) {
            if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
              var getElesByTagName = document.getElementsByTagName.bind(document);
              scrollTop = getElesByTagName('html')[0].scrollTop || getElesByTagName('body')[0].scrollTop;
            }

            $id.style.left = "".concat((targetRect.x || targetRect.left) + targetRect.width, "px");
            $id.style.top = "".concat((targetRect.y || targetRect.top) + scrollTop, "px");
          }

          clearTimeout(this.leaveTimeout);
        }
      }
    }
  }, {
    key: "showActiveSubMenu",
    value: function showActiveSubMenu() {
      var type = this.state.type;
      var delay = this.props.delay;
      var subMenuList = null;
      var subMenu = null;
      var i = 0;
      var len = 0;

      if (this.groupRef && type === 'mini') {
        subMenuList = this.groupRef.getElementsByTagName('li');
        len = subMenuList.length;

        for (; i < len; i++) {
          subMenu = subMenuList[i];

          if (subMenu && subMenu.getAttribute('data-toplevel') && subMenu.getAttribute('data-open') === '1') {
            this.showSubMenu(subMenu.getAttribute('data-index'), subMenu.getBoundingClientRect());

            if (delay > 0) {
              this.hideSubMenuWhenLeave(delay);
            }
          }
        }
      }
    }
  }, {
    key: "hideSubMenuWhenLeave",
    value: function hideSubMenuWhenLeave() {
      var _this5 = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
      var type = this.state.type;

      if (type === 'mini') {
        clearTimeout(this.leaveTimeout);
        this.leaveTimeout = setTimeout(function () {
          _this5.hideSubMenu();
        }, timeout);
      }
    }
  }, {
    key: "handleMenuItemMouseEnter",
    value: function handleMenuItemMouseEnter(event) {
      var onMenuItemMouseEnter = this.props.onMenuItemMouseEnter;
      var type = this.state.type;
      var currentTarget = event.currentTarget; // const className = currentTarget.className;
      // if (className.indexOf('mouseenter') < 0) {
      //     currentTarget.className = className + ' mouseenter';
      // }

      if (type === 'mini') {
        clearTimeout(this.leaveTimeout);
      }

      if (currentTarget.getAttribute('data-toplevel') && type === 'mini') {
        this.showSubMenu(currentTarget.getAttribute('data-index'), currentTarget.getBoundingClientRect());
      }

      if ((0, _spauiUtils.isFunction)(onMenuItemMouseEnter)) {
        onMenuItemMouseEnter(event);
      }
    }
  }, {
    key: "handleMenuItemMouseLeave",
    value: function handleMenuItemMouseLeave(event) {
      var onMenuItemMouseLeave = this.props.onMenuItemMouseLeave; // const currentTarget = event.currentTarget;
      // const className = currentTarget.className;
      // if (className.indexOf('mouseleave') < 0) {
      //     currentTarget.className = className + ' mouseleave';
      // }

      this.hideSubMenuWhenLeave(event);

      if ((0, _spauiUtils.isFunction)(onMenuItemMouseLeave)) {
        onMenuItemMouseLeave(event);
      }
    }
  }, {
    key: "handleMenuItemTransitionEnd",
    value: function handleMenuItemTransitionEnd(event) {
      var onMenuItemTransitionEnd = this.props.onMenuItemTransitionEnd; // const currentTarget = event.currentTarget;
      // const className = currentTarget.className;
      // const classArray = className.split(' ');
      // let result = [];
      // classArray.map((item) => {
      //     if (item !== 'mouseenter' && item !== 'mouseleave') {
      //         result.push(item);
      //     }
      //     return item;
      // });
      // currentTarget.className = result.join(' ');

      if ((0, _spauiUtils.isFunction)(onMenuItemTransitionEnd)) {
        onMenuItemTransitionEnd(event);
      }
    }
  }, {
    key: "handleMenuGroupTransitionEnd",
    value: function handleMenuGroupTransitionEnd(event) {
      var onMenuGroupTransitionEnd = this.props.onMenuGroupTransitionEnd;
      this.updateMenuHeight();

      if ((0, _spauiUtils.isFunction)(onMenuGroupTransitionEnd)) {
        onMenuGroupTransitionEnd(event);
      }
    }
  }, {
    key: "updateMenuHeight",
    value: function updateMenuHeight() {
      var needForceUpdateHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var getDomStyle = function getDomStyle(dom, attr) {
        var result = (0, _spauiUtils.getStyle)(dom, attr);
        result = parseInt(result, 10) || 0;
        return result;
      };

      var type = this.state.type;
      var subMenuList = null;
      var i = 0;
      var len = 0;
      var subMenu = null;
      var subMenuHeight = 0;
      var aDom = null;
      var ulDom = null;
      var dataHeight = '';

      if (this.props.openSmoothly && this.groupRef) {
        subMenuList = this.groupRef.getElementsByTagName('li');
        len = subMenuList.length;

        for (; i < len; i++) {
          subMenu = subMenuList[i];

          if (subMenu.className && subMenu.className.indexOf('has-submenu') > -1) {
            if (type === 'mini') {
              subMenu.style.setProperty('--height', '');
            } else {
              aDom = subMenu.getElementsByTagName('a')[0];
              ulDom = subMenu.getElementsByTagName('ul')[0];
              dataHeight = subMenu.getAttribute('data-height');

              if (aDom && ulDom && (!dataHeight || needForceUpdateHeight)) {
                subMenuHeight = getDomStyle(aDom, 'paddingTop');
                subMenuHeight = subMenuHeight + getDomStyle(aDom, 'height');
                subMenuHeight = subMenuHeight + getDomStyle(aDom, 'paddingBottom');
                subMenuHeight = subMenuHeight + getDomStyle(ulDom, 'paddingTop');
                subMenuHeight = subMenuHeight + getDomStyle(ulDom, 'height');
                subMenuHeight = subMenuHeight + getDomStyle(ulDom, 'paddingBottom');
                subMenu.setAttribute('data-height', subMenuHeight);
              } else {
                subMenuHeight = dataHeight;
              }

              subMenu.style.setProperty('--height', "".concat(subMenuHeight, "px"));
            }
          }
        }
      }
    } // 获取下自定义的参数

  }, {
    key: "getCustomProps",
    value: function getCustomProps() {
      var props = this.props || {};
      var propTypes = Menu.propTypes || {};
      var key = '';
      var result = {};

      for (key in props) {
        if (typeof propTypes[key] === 'undefined' && key !== 'style' && key !== 'className' && key !== 'id') {
          result[key] = props[key];
        }
      }

      return result;
    } // 获取下可以显示的data(排除hide)

  }, {
    key: "getData",
    value: function getData(props) {
      var _ref = props || this.props,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? [] : _ref$data,
          _ref$hideValue = _ref.hideValue,
          hideValue = _ref$hideValue === void 0 ? [] : _ref$hideValue;

      var addNodeData = function addNodeData() {
        var dataList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var newDataList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        dataList.map(function (item) {
          var newItem = {};

          if (item) {
            newItem = _objectSpread({}, item, {
              data: []
            });

            if (item.data && item.data.length > 0) {
              addNodeData(item.data, newItem.data);
            } // 不能是隐藏的


            if ((typeof newItem.hide === 'undefined' || !newItem.hide) && (0, _spauiUtils.indexOf)(hideValue, newItem.href) < 0 && (0, _spauiUtils.indexOf)(hideValue, newItem.key) < 0) {
              // 存放下原始的节点数据
              newItem._origin = item;
              newDataList.push(newItem);
            }
          }

          return item;
        });
      };

      var result = [];
      addNodeData(data, result);
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _compactProps4 = (0, _compact_props["default"])(this.props),
          toggle = _compactProps4.toggle;

      var type = this.state.type;
      var data = this.getData();
      return _react["default"].createElement(_dom_component["default"], _extends({
        id: this.id
      }, this.props, {
        data: data,
        customProps: this.getCustomProps(),
        devProps: [Menu, this.props],
        toggle: toggle,
        type: type,
        onTypeChange: this.handleTypeChange,
        isActive: this.isActive,
        onChange: this.handleChange,
        onMenuItemMouseEnter: this.handleMenuItemMouseEnter,
        onMenuItemMouseLeave: this.handleMenuItemMouseLeave,
        onMenuItemTransitionEnd: this.handleMenuItemTransitionEnd,
        onMenuGroupTransitionEnd: this.handleMenuGroupTransitionEnd,
        groupRef: function groupRef(el) {
          _this6.groupRef = el;
        }
      }));
    }
  }]);

  return Menu;
}(_react.PureComponent); // 组件标记


_defineProperty(Menu, "propTypes", {
  data: _spauiUtils.PropTypes.array.isRequired,
  value: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number]),
  show: _spauiUtils.PropTypes.bool,
  hideValue: _spauiUtils.PropTypes.array,
  defaultOpenValue: _spauiUtils.PropTypes.bool,
  onChange: _spauiUtils.PropTypes.func,
  showOpenSubMenuInDidMount: _spauiUtils.PropTypes.bool,
  open: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.array, _spauiUtils.PropTypes.number]),
  onOpen: _spauiUtils.PropTypes.func,
  toggleTitle: _spauiUtils.PropTypes.string,
  toggleProps: _spauiUtils.PropTypes.object,
  toggle: _spauiUtils.PropTypes.bool,
  groupClassName: _spauiUtils.PropTypes.string,
  type: _spauiUtils.PropTypes.string,
  miniClassNameInBody: _spauiUtils.PropTypes.string,
  defaultType: _spauiUtils.PropTypes.string,
  fixed: _spauiUtils.PropTypes.bool,
  onTypeChange: _spauiUtils.PropTypes.func,
  onMenuItemMouseEnter: _spauiUtils.PropTypes.func,
  onMenuItemMouseLeave: _spauiUtils.PropTypes.func,
  onMenuItemTransitionEnd: _spauiUtils.PropTypes.func,
  onMenuGroupTransitionEnd: _spauiUtils.PropTypes.func,
  HeaderComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  FooterComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ItemComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  LinkComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ToggleComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  IconComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  transitionWidthTime: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]),
  triggerWindowResizeWhenTypeChange: _spauiUtils.PropTypes.bool,
  delay: _spauiUtils.PropTypes.number,
  showPortalMenuWhenNoSubmenu: _spauiUtils.PropTypes.bool,
  version: _spauiUtils.PropTypes.string,
  nodeIsSelected: _spauiUtils.PropTypes.func,
  nodeIsOpen: _spauiUtils.PropTypes.func,
  openSmoothly: _spauiUtils.PropTypes.bool,
  width: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string])
});

_defineProperty(Menu, "defaultProps", {
  // show 该属性需要一直保持为undefined，因为前期是通过data.length判断的，如果有值后就会有作用
  fixed: false,
  defaultType: 'normal',
  data: [],
  toggle: true,
  toggleTitle: '展开/收起菜单',
  toggleProps: {},
  showOpenSubMenuInDidMount: true,
  transitionWidthTime: 300,
  triggerWindowResizeWhenTypeChange: false,
  delay: 1500,
  showPortalMenuWhenNoSubmenu: true,
  version: '',
  miniClassNameInBody: 'spaui-menu-mini-in-body',
  hideValue: [],
  defaultOpenValue: false,
  ToggleComponent: _toggle_component["default"],
  IconComponent: _icon_component["default"],
  ItemComponent: _item_component["default"],
  LinkComponent: _link_component["default"],
  nodeIsSelected: _index.nodeIsSelected,
  nodeIsOpen: _index.nodeIsOpen,
  openSmoothly: true
});

(0, _spauiUtils.setComponentMark)(Menu, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Menu;
exports["default"] = _default;